import type {
  GameStructure,
  HGGetClubTournStructuresReply
} from '@swf/generated/types/api/v0/SwHomeGames';

const canEnableVideo = (
  structures: HGGetClubTournStructuresReply | undefined,
  handType: GameStructure['handType'],
  isHiLo: boolean,
  potStruct: string,
  tableSize: number
): boolean => {
  if (!handType || !structures || !tableSize || !potStruct) {
    return false;
  }

  const structure = structures.gameStructures?.find(
    (struct) => struct.handType === handType && struct.hiLo === isHiLo
  );

  if (!structure || !structure.videoChatFilter || !structure.videoChatFilter.length) return false;

  const videoChatFilter = structure.videoChatFilter.find((filter) =>
    filter.potTypes?.includes(potStruct as never)
  );

  if (!videoChatFilter) return false;

  return !!videoChatFilter.tableSizes?.includes(tableSize);
};

export default canEnableVideo;
